let info = {
  name: "Andrea Ierardi",
  logo_name: "Andrea",
  flat_picture: require("./src/assets/profile.jpg"),
  config: {
    use_cookies: true,
    navbar: {
      blur: false
    }
  },
  description:
    "AI Manager in Customer Experience team with experience leading ML and GenAI projects end to end, from data ingestion and warehousing to deployment in customer facing products. I guide multidisciplinary teams to deliver scalable, governed AI solutions, with strong focus on MLOps, monitoring, and model reliability in production. I work closely with marketing, IT, and product to turn customer analytics into churn prevention, upselling, channel preference modeling, and next best action systems that drive measurable business impact. Experienced across AWS, Azure, and GCP, and passionate about mentoring developers and bridging business and technical teams to operationalize AI at scale. \
    <br> <br> \
    Outside of work, I enjoy exploring new cultures and practicing bonsai care.",
  links: {
    linkedin: "https://www.linkedin.com/in/andreaierardi/",
    github: "https://github.com/andreaierardi",
    instagram: "https://instagram.com/andreaierardi",
    twitter: "https://twitter.com/andrea_ierardi",
    //resume:
    //  "https://github.com/hrishikeshpaul/portfolio-template/blob/master/src/assets/pdfs/Resume.pdf"
  },
  experience: [
      {
      name: "Lundbeck",
      place: "Copenahgen, Denmark",
      date: "July, 2024 - Present",
      position: "AI Manager",
      description:["Led a 10-person team (ML, GenAI, Data Engineering) delivering global AI/ML solutions, managing sprint planning, prioritization, and releases in agile environments.",
  "Partnered with global IT, marketing, and commercial teams to deliver Next Best Action and AI-driven insights in customer-facing tools, including UAT and post-launch A/B testing.",
  "Oversaw end-to-end data pipelines from source systems to Snowflake and downstream platforms such as Veeva CRM and Salesforce Marketing Cloud.",
  "Designed and implemented MLOps foundations (CI/CD, Terraform, monitoring) to ensure scalable and compliant model deployment.",
  "Built and deployed enterprise-grade Generative AI solutions, including LLM chatbots and summarization tools, to support sales teams."],
      logo_link:"https://www.lundbeck.com/content/dam/lundbeck-com/masters/global-site/media-library/images/logo/LUNDBECK-logo-RGB.png.coredownload.png",
      skills: ["Python", "Azure", "Snowflake", "SQL", "DBT", "MLOps", "Generative AI", "Langchain", "RAG", "Chatbot"]
    },
    {
      name: "Start2Impact",
      place: "Copenahgen, Denmark",
      date: "July, 2024 - Present",
      position: "AI Mentor",
      description:["Mentoring and guiding students in their AI projects, providing technical support and advice on best practices in AI development.",],
      logo_link:"https://s3-eu-west-1.amazonaws.com/tpd/logos/5f391082b58bc500010a504c/0x0.png",
      skills: ["AI", "Mentoring", "Project Guidance" ]
    },
    {
      name: "SKY",
      place: "Italy",
      date: "Nov, 2022 - July, 2024",
      position: "Senior Machine Learning Engineer",
      description:[
        "Led multiple AI/ML projects including retail optimization, content scheduling (Genetic Algorithms), and upselling, delivering ahead of schedule with GCP, Airflow, and BigQuery, reducing industrialization time by 50%.",
        "Mentored junior team members and supported sprint planning for delivery of ML features.",
        "Won 3rd place at the Google & SKY UK GenAI Hackathon (11 teams) for innovative AI solutions.",
        "Built a Data Smart Assistant with LLMs, RAG, and LangChain to enhance internal data accessibility."],
      logo_link:"data:image/jpeg;base64,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",
      skills: ["Python", "Google Cloud Platform", "SQL", "Airflow", "MLOps", "Pandas", "GenAI", "Langchain"]
    },
    {
      name: "Fastweb",
      place: "Italy",
      date: "Jan, 2022 - Nov, 2022",
      position: "Data Scientist",
      description:
      ["Developed ETL data pipeline in AWS, analyzed data extrapolating important insights for the business unit using Numpy, Pandas and Matplotlib python libraries.",
      "Developed supervised Machine Learning models predicting customer's up-selling increasing 4 times the customer care services using Sklearn python library.",
      "Developed Unsupervised Customer Segmentation models for targeting up-selling campaigns."],
      logo_link:"https://www.fastweb.it/adsl-fibra-ottica/gfx/loghi/logo-fw-simple-yellow.svg",
      skills: ["Python", "Amazon Web Services", "Sklearn", "Pandas", "Storytelling"]
    },
    {
      name: "Borsa Italiana",
      place: "Italy",
      date: "Feb, 2021 - Oct, 2021",
      position: "Data Scientist & ML Engineer",
      description:

      [      "Modelling, Clustering and Forecasting Post Trade data: built ML production pipeline in cloud",
      "Worked with the team extracting post trade data, creating machine learning and deep learning models to forecast next business day for important Italian banks.",
      "Helped treasurer allocating cash flow forecasting next business day and reduced cost for million of euros using Deep Learning models.",
      "Master's Thesis: Social Network Analysis on Post Trade Data: Centrality, Scale-free behavior and resiliency of the networks over time"],
      logo_link:"data:image/jpeg;base64,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",
      skills: ["Python", "Amazon Web Services", "Sklearn", "Neural Networks", "Tensorflow", "Social Network Analysis", "Pandas"]
    },

  ],
  education: [
    {
      name: "University of Milan",
      place: "Italy",
      date: "Oct, 2019 - Jun, 2022",
      degree: "Masters in Data Science and Economics",
      //gpa: "26/30",
      description:
        ["Thesis: Social Network Analysis on post trade data: centrality, scale free behavior and resiliency of the networks over time."],
        logo_link:"https://www.unimi.it/sites/default/files/2019-05/LogoFooter_a9f0c3692bf29c71609e5f204522c5d4_0.png",
        skills: [
        "Artificial Intelligence",
        "Machine Learning",
        "Data Science",
        "Data Mining",        
        "Advanced Economics",
        "Advanced Statistics",
      
      ]
    },
    {
      name: "University of Eastern Piedmont",
      place: "Italy",
      date: "Oct, 2016 - Oct, 2019",
      degree: "Bachelors in Computer Science",
      //gpa: "8.0/10.0",
      description:
        ["Thesis: MMS protocol attacks."],
        logo_link:"data:image/png;base64,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",
        skills: [
        "C",
        "Java",
        "Python",
        "Web Development",
        "Concurrent Programming",
        "CyberSecurity",
        "Software Engineering",
        "OS"
      ]
    }
  ],
  skills: [
    {
      title: "languages",
      info: [
        "Python",
        "SQL",
        "NoSQL",
        "R",
        "Java",
        "C"
      ],
      icon: "fa fa-code"
    },
    {
      title: "data frameworks",
      info: [
        "Keras",
        "Numpy",
        "Pandas",
        "Tensorflow",
        "Sklearn",
        "LangChain",
        "LangGraph",
        "HuggingFace",
      ],
      icon: "fa fa-cubes"
    },
    {
      title: "Cloud",
      info: [
        "Azure",
        "Amazon Web Services",
        "Google Cloud Platform",
        "Snowflake",
        "dbt"

      ],
      icon: "fa fa-cloud"
    },
    {
      title: "databases",
      info: ["Google BigQuery","MongoDB", "MySQL", "Snowflake Query"],
      icon: "fa fa-database"
    },
    {
      title: "operating systems & tools",
      info: [
        "MacOS",
        "Ubuntu",
        "Windows",
        "Agile",
        "JIRA",
        "Slack",
        "Heroku",
      ],
      icon: "fas fa-tools"
    },
    {
      title: "web technologies",
      info: ["Django", "Flask", "HTML", "CSS", "BI Dashboards", "Shinyapp", "Streamlit"],
      icon: "fas fa-laptop-code"
    },
  ],

  /*
  portfolio: [
    {
      name: "Social Network Analysis on post trade data: \
      Centrality, scale free behavior and resiliency of the networks over time",
      pictures: [
        {
          img: require("./src/assets/portfolio/sna_borsaitaliana/one.png")
        },
        {
          img: require("./src/assets/portfolio/sna_borsaitaliana/one.png")
        },
        {
          img: require("./src/assets/portfolio/sna_borsaitaliana/three.png")
        },
        {
          img: require("./src/assets/portfolio/sna_borsaitaliana/five.png")
        },
        {
          img: require("./src/assets/portfolio/sna_borsaitaliana/six.png")
        },
        {
          img: require("./src/assets/portfolio/sna_borsaitaliana/seven.png")
        },       
      ],
      technologies: ["Computer Vision", "OpenCV", "AI", "Flask", "Sockets"],
      category: "Algorithm",
      date: "Jan, 2020 - Mar, 2020",
      github:
        "https://github.com/hrishikeshpaul/music-sheet-recognizer-backend",
      visit: "https://github.com/hrishikeshpaul/music-sheet-recognizer-backend",
      description:
      "The aim of the thesis is the extraction, study and analysis of post-trade data from Monte Titoli, applying social network analysis. \
      Several analysis are performed for daily and monthly networks: \
      \
      Monthly Graph (cumulative and non-cumulative): inspectional analysis on the overall structure of the networks, centrality analysis, node importance and scale-free pattern detection and networks resiliency.\
      Daily Graph: analysis of disruptive events.Two case are considered: the impact of Covid19 and BTP emissions on networks topology."
    },
    {
      name: "NoQ Job Portal",
      pictures: [
    /*    {
          img: require("./src/assets/portfolio/noq/logo.png")
        },
        {
          img: require("./src/assets/portfolio/noq/one.png")
        },
        {
          img: require("./src/assets/portfolio/noq/two.png")
        },
        {
          img: require("./src/assets/portfolio/noq/three.png")
        },
        {
          img: require("./src/assets/portfolio/noq/four.png")
        } 
      ],
      technologies: ["Node", "Vue", "Express", "MongoDB", "Heroku"],
      category: "Website",
      date: "Sep, 2019 - Dec  , 2019",
      github: "https://github.com/hrishikeshpaul/noq",
      visit: "https://noq-client.herokuapp.com/",
      description:
        "No Q, is a revolutionary tool which allows for both employers and students to skip the hassle seen in modern day career fairs. For the students, there is an intuitive profile builder where you can add things like education, skills, certifications, honors, and experiences. No Q is not only good for students, but employers as well! A common problem at modern career fairs is the number of unqualified candidates who waste their time when they could be chatting with someone else. With No Q, only the students who meet the positions’ criteria will be able to apply, and from there the recruiter can invite them to talk in more detail at the career fair through our intuitive messaging system."
    },
    {
      name: "POST",
      pictures: [
        {
          img: require("./src/assets/portfolio/post/one.png")
        },
        {
          img: require("./src/assets/portfolio/post/two.png")
        }
      ],
      technologies: [
        "Markov Models",
        "Python",
        "Artificial Intelligence",
        "Vue",
        "Heroku"
      ],
      category: "Algorithm",
      github: "https://github.com/hrishikeshpaul/pos-tagger",
      date: "Oct, 2019 - Nov, 2019",
      visit: "https://post-client.herokuapp.com/",
      description:
        "Post is a simple algorithm that was developed to tagging a word corresponding to its part of speech. The algorithm makes of a probabilisitic approach along with some randomness, together which forms the basis of an algorithm called Gibbs Sampling."
    },
    {
      name: "Suicide Analyzer",
      pictures: [
       /* {
          img: require("./src/assets/portfolio/suicide/suicide-analyzer.png")
        },
        {
          img: require("./src/assets/portfolio/suicide/suicide2-original.png")
        }
      ],
      technologies: ["Node", "Angular", "Express", "Leaflet", "Pandas"],
      category: "Website",
      date: "Oct, 2018 - Nov, 2018",
      github: "https://github.com/hrishikeshpaul/whodata",
      visit: "https://skylarktiral.herokuapp.com/",
      description:
        "This is a web application, uses a map to demonstrate the number suicides committed around the globe, according to a dataset provided by the WHO. The application consists of a Leaflet map that colors every nation, based on the number of suicides that have been committed in that country, for that year. It provides us with the capability to select the data as well as the continent."
    },
    {
      name: "Sentiment Analyzer",
      pictures: [
      /*  {
          img: require("./src/assets/portfolio/smit/one.png")
        },
        {
          img: require("./src/assets/portfolio/smit/two.png")
        },
        {
          img: require("./src/assets/portfolio/smit/three.png")
        },
        {
          img: require("./src/assets/portfolio/smit/four.png")
        } 
      ],
      technologies: ["LSTM", "Keras", "Angular", "Tweepy", "Heroku", "Python"],
      category: "Alogrithm",
      date: "Feb, 2018 - Apr  , 2018",
      github: "https://github.com/hrishikeshpaul/sih",
      visit: "https://angel.co/projects/1009777-sentiment-analysis",
      description:
        "Developing this for the final round of Smart India Hackathon 2018, the web application is a platform for showcasing the sentiment of the tweets of the people in the Telangana region in India on policy satisfaction, services and problem definitions. The minimal UI design consists of different bins, that have their respective tweets, all scraped from twitter. There is also a simple graphical representation denoting the sentiment of the tweets."
    },
    {
      name: "Clumpr",
      pictures: [
     /*   {
          img: require("./src/assets/portfolio/clumpr/logo.png")
        },
        {
          img: require("./src/assets/portfolio/clumpr/one.png")
        },
        {
          img: require("./src/assets/portfolio/clumpr/two.png")
        } 
      ],
      technologies: ["Node", "Angular", "Express", "MySQL", "Facebook API"],
      category: "Web App",
      github: "https://github.com/hrishikeshpaul/clumpr",
      date: "Sep, 2017 - Nov, 2017",
      visit: "https://github.com/hrishikeshpaul/clumpr",
      description:
        'Clumpr is an online social event planning assistant that - using information about similar events happening in similar locations around the same time, friends who frequently attend the same events, and mutual friends - helps users to collaborate, combine, and attend events together, effectively "clumping" people and activities in a way that makes intuitive sense.'
    },
    {
      name: "Nutricare",
      pictures: [
        /*{
          img: require("./src/assets/portfolio/nc/one.png")
        },
        {
          img: require("./src/assets/portfolio/nc/two.png")
        },
        {
          img: require("./src/assets/portfolio/nc/three.png")
        },
        {
          img: require("./src/assets/portfolio/nc/four.png")
        },
        {
          img: require("./src/assets/portfolio/nc/five.png")
        },
        {
          img: require("./src/assets/portfolio/nc/six.png")
        } 
      ],
      technologies: ["Node", "Angular", "Express", "MongDB", "Medical"],
      category: "Website",
      github: "https://github.com/hrishikeshpaul/clumpr",
      date: "May, 2017 - Aug, 2017",
      visit: "https://angel.co/projects/576300-nutricare",
      description:
        "Nutricare is a basic health website for users(patients) to input nutrient intake data and researchers to analyse the data with the help of graphs and tables. A researcher can conduct studies on N different subjects (patient) for a particular problem statement. Typically, a researcher will enter food item consumed by subjects over a period of time (Ex - 24hrs, or 1 week, or 1 month etc)."
    }
  ], */
  portfolio_projects: [
    {
      title: "MLOps Sentiment Analysis",
      name: "MLOps Reviews Sentiment Prediction",
      pictures: [
        {
          img: require("./src/assets/portfolio/mlops_amazon_reviews/architecture.png")
        },
      ],
      technologies: [],
      category: "Artificial Intelligence",
      github: "https://github.com/Andreaierardi/mlops-amazon-reviews",
      date: "2025",
      visit: "https://github.com/Andreaierardi/mlops-amazon-reviews/blob/main/README.md",
      description:
      'This project trains and serves a sentiment classifier that categorizes review sentences into positive, neutral, or negative classes.\
      Each review is split into individual sentences, and each sentence inherits the review’s star rating as its label.'
 
    },
    {
      title: "Social Network Analysis on post trade data",
      name: "Social Network Analysis on post trade data: \
      Centrality, scale free behavior and resiliency of the networks over time",
      pictures: [
        {
          img: require("./src/assets/portfolio/sna_borsaitaliana/one.png")
        },
        {
          img: require("./src/assets/portfolio/sna_borsaitaliana/two.png")
        },
        {
          img: require("./src/assets/portfolio/sna_borsaitaliana/three.png")
        },
        {
          img: require("./src/assets/portfolio/sna_borsaitaliana/five.png")
        },
        {
          img: require("./src/assets/portfolio/sna_borsaitaliana/six.png")
        },
        {
          img: require("./src/assets/portfolio/sna_borsaitaliana/seven.png")
        },       
      ],
      technologies: [],
      category: "Artificial Intelligence",
      github: "https://github.com/Andreaierardi/Master-Thesis-SNA-Borsa-Italiana",
      date: "August, 2021 - Jun 2022",
      visit: "https://github.com/Andreaierardi/Master-Thesis-SNA-Borsa-Italiana/blob/main/Presentations/andrea_ierardi_presentation_DSE.pdf",
      description:
      'The aim of the thesis is the extraction, study and analysis of post-trade data from Monte Titoli, applying social network analysis.\
      Several analysis are performed for daily and monthly networks: \
       <ul> <li> Monthly Graph (cumulative and non-cumulative): inspectional analysis on the overall structure of the networks, centrality analysis, node importance and scale-free pattern detection and networks resiliency. </li> <li> Daily Graph: analysis of disruptive events.Two case are considered: the impact of Covid19 and BTP emissions on networks topology.</li> </ul> '
    },
  
    {
      title: "Market Basket Analysis",
      name: "Market Basket Analysis: \
      IMDB Movies and Actors",
      pictures: [
        {
          img: require("./src/assets/portfolio/market_basket_analysis/marketbasketanalysis.png"),
          title: "Market Basket Analysis"
        }
      ],
      technologies: ["MBA", "PySpark", "Frequent Patten Growth"],
      category: "Artificial Intelligence",
      date: "Dec, 2021",
      visit: "https://github.com/Andreaierardi/Market-Basket-Analysis-IMDB/blob/main/Report/IERARDI_AMD_Project_report_.pdf",
      github: "https://github.com/Andreaierardi/Market-Basket-Analysis-IMDB",
      code: "https://github.com/Andreaierardi/Market-Basket-Analysis-IMDB/blob/main/Notebook/AMD_project.ipynb",
      description:
        '<div class="text_margin"> The task is to implement a system finding frequent itemsets (aka market-basket analysis), analyzing the IMDB dataset.  <br>  \
        The «<a target="_blank"  href="https://www.kaggle.com/ashirwadsangwan/imdb-dataset" >IMDB </a>» dataset is published on Kaggle, under <a target="_blank"  href="https://www.imdb.com/conditions?pf_rd_m=A2FGELUUNOQJNL&pf_rd_p=3aefe545-f8d3-4562-976a-e5eb47d1bb18&pf_rd_r=K7VGSA5BY26HTH7KAGZV&pf_rd_s=center-1&pf_rd_t=60601&pf_rd_i=interfaces&ref_=fea_mn_lk2"> IMDb non-commercial licensing </a>. \        <br>                  <br> \
        The analysis considers movies as baskets and actors as items: \
         <br> \
         <li class="card-text">Frequent Patten Growth Algorithm: identification of Frequent Item-sets and Association Rules. </li> \
         <li class="card-text">Tools: Python, PySpark </li> \
          \
          \<br> </div>'
    },
    
    {
      name: "Puccini by Email Sentiment Polarity Models",
      title: "Puccini by Email Sentiment Polarity Models",
      pictures: [
        {
          img: require("./src/assets/portfolio/puccini/puccini.jpg"),
          title: "Puccini"
        },
      ],
      technologies: ["Sentiment Analysis", "ML", "NLP"],
      category: "Artificial Intelligence",
      github: "https://github.com/Andreaierardi/sentiment-puccini",
      date: "Jan 2022",
      visit: "https://github.com/Andreaierardi/sentiment-puccini/blob/main/report%20%26%20presentation/info-retr-presentation.pdf",
      code: "https://github.com/Andreaierardi/sentiment-puccini/blob/main/notebook/sentiment_Puccini.ipynb",
      description: 
      'The aim of the project is the retrieval of Giacomo Puccini letters from official website, developing and application of pre-trained models for letters sentiment polarity classification over the years. \
      <br> Dataset Links: <a target="_blank" href="https://www.digitalarchivioricordi.com/it/people/display/2/Giacomo%20Puccini"> Archivio Ricordi  </a> and <a  target="_blank" href="http://www.di.unito.it/~tutreeb/sentipolc-evalita16/">  Sentipolc-evalita16 </a> <br><br> \
      Different models applied : <ul> \
        <li> Simple Neural Network models  </li> \
        <li  > <a target="_blank" href="https://nicgian.github.io/Sentita/"> SentITA </a>  models </li> \
        \
        \<br> </ul>'
    },
    {
      name: "Detect Emotion in lyrics song: Django DashBoard",
      title: "Detect Emotion in lyrics song: Django DashBoard",
      pictures: [
        {
          img: require("./src/assets/portfolio/lyrics_emotion/lyrics_emotion.png"),
          title: "Lyrics Emotion - Dashboard"
        },
      ],
      technologies: ["Django", "Neural Networks", "Songs", "NLP", "Sentiment-Analysis"],
      category: "Artificial Intellince",
      github: "https://github.com/Andreaierardi/lyrics-emotion-detection",
      date: "May, 2020 - July, 2020",
      visit: "https://github.com/Andreaierardi/lyrics-emotion-detection/blob/main/report%26presentation/text-mining-presentation.pdf",
      code: "https://github.com/Andreaierardi/lyrics-emotion-detection/blob/main/PythonNotebook/emotion_detection.ipynb",
      description:
      '  The aim of the project is the the developing of different models for predicting the emotions in text lyrics. Moreover, a simple web application has been developed for the deploying of the work. \
      <br>                  <br> \
      Different sections : <ul> \
        <li> Home page: Emotion prediction   </li> \
        <li> Data page: Data description and plots </li> <br> </ul>'
    },
    {
      name: "Facebook Food likes Network: Social Networks Analysis",
      title: "Facebook Food likes Network: Social Networks Analysis",
      pictures: [
        {
          img: require("./src/assets/portfolio/sna_project/network.png"),
          title: "Food Network"
        }
      ],

//,
//         {
//           img: '<div id = "mynetwork"></div>\
// \
//           <div id="loadingBar">\
//               <div class="outerBorder">\
//                   <div id="text">0%</div>\
//                   <div id="border">\
//                       <div id="bar"></div>\
//                   </div> \
//               </div> </div>',
//           title: "Food likes Network"
//         },
      technologies: ["Python", "SNA"],
      category: "Artificial Intelligence",
      github: "https://github.com/Andreaierardi/SocialNetworkAnalysis-project",
      date: "May, 2020 - July, 2020",
      visit: "https://github.com/Andreaierardi/SocialNetworkAnalysis-project/blob/main/Report/report.pdf",
      code:"https://github.com/Andreaierardi/SocialNetworkAnalysis-project/blob/main/Notebooks%20%26%20Gephi%20Projects/project_code.ipynb",
      description:
      '  Data collected about Facebook pages (November 2017). These datasets represent blue verified Facebook page networks of different categories. Nodes represent the pages and edges are mutual likes among them. \
      <br> The dataset is part of a Network Data Repository: <a target="_blank" href="https://networkrepository.com/fb-pages-food.php"> Dataset Link   </a> . <br><br> \
      Different techniques were applied : <ul> \
        <li> Network visualisation using Gephi software    </li>\
        <li> Exploration of the network: Density, average degree, mean, assortativity and connectivity</li>\
        <li> Comparisong with Random Network </li>\
        <li> HUBS </li> \
        <li> Transitivity and Clustering coefficients </li> \
        <li> Centrality </li> \
        <li> Communities using Greedy and Louvain algorithms </li> <br> </ul>'
    },
    {
      title: "Fruit classification with Deep Learning",
      name: "Fruit classification with Deep Learning: Image recognition using Neural Networks",
      pictures: [
        {
          img: require("./src/assets/portfolio/fruits/fruits.webp"),
          title: "Fruits Neural Networks"
        },
      ],
      technologies: ["Python", "SNA"],
      category: "Artificial Intelligence",
      visit: "https://github.com/Andreaierardi/Fruits-Neural-Networks/blob/master/machine_learning_report.pdf",
      code: "https://github.com/Andreaierardi/Fruits-Neural-Networks/blob/master/project_code.ipynb",
      github: "https://github.com/Andreaierardi/Fruits-Neural-Networks",
      date: "May, 2020 - July, 2020",
      description:
      '  The aim of the project is to train neural networks for the classification of fruit and vegetables by using Tensorflow. \
      The dataset is part of a Kaggle Competition: <a href="https://www.kaggle.com/moltean/fruits"> Dataset Link   </a> . <br><br> \
      Different Neural Networks architectures were applied : <ul> \
        <li> Feed-Forward Neural Networks, as input image using PCA for noise image reduction.    </li>\
        <li> VGG Convolutional Neural Networks.</li>\
        <li> LeNet. </li> \
        <li> MobileNetV2. </li> <br></ul>'
    },
    
    {
      title: "New York AirBnB price prediction and cluster analysis",
      name: "New York AirBnB price prediction and cluster analysis",
      pictures: [
        {
          img: require("./src/assets/portfolio/ny/ny.webp"),
          title: "Cluster analysis"
        },
      ],
      technologies: ["Python", "SNA"],
      category: "Artificial Intelligence",
      date: "May, 2020 - July, 2020",
      github: "https://github.com/Andreaierardi/NYAirbnb-Machine-Learning",
      visit: "https://github.com/Andreaierardi/NYAirbnb-Machine-Learning/blob/master/report/report_andreaierardi.pdf",
      code: "https://github.com/Andreaierardi/NYAirbnb-Machine-Learning/blob/master/Project_Code/Code-Export%20files/project-code.pdf",

      description:
      'The aim of the project is to analyse, develop prediction models and define  clusters of the \
      data from "New York City Airbnb Open Data" Kaggle competition. <br> \
      One part of the study is focused on the development\
      of predictive models to forecast house prices using these Supervised Learning technics:\
      <strong> Linear Regression, Decision Tree, Random Forest, Random Forest, Neural Networks   </strong>. <br>\
      For each of these, a comparison between the Mean Square Error of all methods has been made to highlight \
      which have the best performance.     <br>\
      The second part is focused on the cluster and data reduction technics using these Unsupervised Learning technics:\
      <strong>K-means Algorithm and Clustering for mixed-type data, Hierarchical clustering, Principal Component Analysis for mixed-type data   </strong>.'
    },

    {
 
      title: "Covid19 Forecast Evaluation",
      name: "Covid19 Forecast Evaluation",
      pictures: [
        {
          img: require("./src/assets/portfolio/covid19_django/covid_django.png"),
          title: "Django Dashboard"
        },
      ],
      technologies: ["Python", "Django", "Javascript", "Web Development"],
      category: "Dashboard",
      date: "",
      github: "https://github.com/Andreaierardi/Covid-19-Forecast-Evaluation",
      visit: "https://forecast-evaluation.herokuapp.com",

      description:"                    The project is a study between University of Milan, University of York, University College Dublin & CAMA. \
      Covid19 data collected from the CDC about USA cases. For the data retrieval we used Zoltarpy Python API. We used HTML, CSS, JS and AJAX for the front-end and Python Django for the back-end.  <br><br>\
        Different sections : \
        <ul> \
          <li> Home page: visualisation of forecast data with real data   </li>\
          <li> Data page: table data visualisation and download </li>\
          <li> Authors section </li>\
          <li> Documentation </li>\
          <br> </ul>"
    },    
    {
 
      title: "DisCOVIDer19",
      name: "DisCOVIDer19 a navigation through the pandemic",
      pictures: [
        {
          img: require("./src/assets/portfolio/covid19_shiny/covid19shiny.webp"),
          title: "Main page"
        },       
        {
          img: require("./src/assets/portfolio/covid19_shiny/covid19shiny2.webp"),
          title: "Second page"
        },
      ],
      technologies: ["R", "ShinyApp"],
      category: "Dashboard",
      date: "",
      github: "https://github.com/Andreaierardi/disCOVIDer19",
      visit: "https://andreaierardi.shinyapps.io/disCOVIDer19",

      description:"ShinyApp disCOVIDer19 offers a full immersion into the COVID-19 outbreak in Italy, collecting data from main italian public sources and presenting it in a great variety of charts. The cumulative cases of virus infection are used for a growth modelling section labelled 'Analysis', which features several ways of shaping the growth: the logistic model, \
      the ARIMA model and the SEIR model. Metrics have been estimated and are suggested to the user. \
  </div> \
  <a target='_blank' class='cta-btn cta-btn--hero' href='https://andreaierardi.shinyapps.io/disCOVIDer19/'> \
    See Live  <i class='icon fa fa-rocket'></i> \
  </a>  <a target='_blank' class='cta-btn text-color-main' href='https://github.com/marzione00/COVID_19_HACK'> \
    Source Code \
  </a>  <div> \
    <h1> Citations </h1> \
    <p class='mb-4 left'> <a target='_blank' class='cta-btn text-color-main' href= 'https://www.meetup.com/it-IT/Lucerne-R-User-Group/events/274011676/'> Talk - Lucerne R User Group </a> \
    </p> \
    <p class='mb-4 left'> <a target='_blank' class='cta-btn text-color-main' href= 'https://www.sis-statistica.it/ita/56/index.php?p=9989'> Società Italiana di Statistica (SIS) - days: 30/03 and 31/03 </a> \
    </p> \
    <p class='mb-4 left'> <a target='_blank' class='cta-btn text-color-main' href= 'https://dse.cdl.unimi.it/en/avviso/notice-detail/covid-data-analysis'> University of Milan </a> \
    </p> <p class='mb-4 left'> <a target='_blank' class='cta-btn text-color-main' href= 'https://zenodo.org/record/3740132#.Xozz5i-pW-o'> Zenodo pubblication </a> \
    </p>   </div> <div> <h1> Contributors </h1>  <br>  <ul> <li class='mb-4 left'> Andrea Ierardi     <br> <a href='https://www.linkedin.com/in/andreaierardi/' rel='nofollow noreferrer'> <img src='https://i.stack.imgur.com/gVE0j.png' alt='linkedin'> LinkedIn </a>  &nbsp;  <a href='https://github.com/Andreaierardi' rel='nofollow noreferrer'> <img src='https://i.stack.imgur.com/tskMh.png' alt='github'> Github </a> &nbsp; \
    </li>  <li class='mb-4 left'>  Marzio De Corato  <br>  <a href='https://www.linkedin.com/in/marzio-de-corato-2351a44b/' rel='nofollow noreferrer'> \
      <img src='https://i.stack.imgur.com/gVE0j.png' alt='linkedin'> LinkedIn \
    </a>  &nbsp; \
    <a href='https://github.com/marzione00' rel='nofollow noreferrer'> <img src='https://i.stack.imgur.com/tskMh.png' alt='github'> Github </a> &nbsp; \
  </li> \
  <li class='mb-4 left'>  Gregorio Saporito <br>  <a href='https://www.linkedin.com/in/greg-saporito/' rel='nofollow noreferrer'> \
    <img src='https://i.stack.imgur.com/gVE0j.png' alt='linkedin'> LinkedIn \
  </a>  &nbsp; \
  <a href='https://github.com/gregorio-saporito' rel='nofollow noreferrer'> <img src='https://i.stack.imgur.com/tskMh.png' alt='github'> Github </a> &nbsp; \
</li> \
<li class='mb-4 left'> \
  Fabio Caironi  <br>  <a href='https://www.linkedin.com/in/fabio-caironi-8361091a2/' rel='nofollow noreferrer'> \
    <img src='https://i.stack.imgur.com/gVE0j.png' alt='linkedin'> LinkedIn \
  </a>  &nbsp; \
  <a href='https://github.com/fabio130497' rel='nofollow noreferrer'> <img src='https://i.stack.imgur.com/tskMh.png' alt='github'> Github </a> &nbsp; </li> <li class='mb-4 left'> Federico Matteucci  <br>   <a href='https://github.com/De-Rham-Cohomology' rel='nofollow noreferrer'> <img src='https://i.stack.imgur.com/tskMh.png' alt='github'> Github </a> &nbsp; </li>  </ul> "
    },
    {
 
      title: "Milan Pollution Analysis",
      name: "Covid19 Forecast Evaluation",
      pictures: [
        {
          img: require("./src/assets/portfolio/milanpollution/milanpollution.webp"),
          title: "Dashboard"
        },
      ],
      technologies: ["ShinyApp", "R"],
      category: "Dashboard",
      date: "",
      github: "https://github.com/Andreaierardi/MilanPollution",
      visit: "https://andreaierardi.shinyapps.io/Milan-Pollution-Analysis",

      description:"The aim of this project is to analysise the datas regarding pollution in Milan from the website of \
      the Comune di Milano. In particular, the study is focused on the different pollutants detected during \
      the years from ARPA stations."
    }, 
    {
 
      title: "SmartBench",
      name: "SmartBench",
      pictures: [
        {
          img: require("./src/assets/portfolio/smartbench/smartbench.webp"),
          title: "Smartbench UI"
        },
      ],
      technologies: ["Java", "Web Development", "Multithreading", "Arduino"],
      category: "Software Engineering",
      date: "",
      github: "https://github.com/Andreaierardi/Smart-Bench/",
      visit: "https://github.com/Andreaierardi/Smart-Bench/blob/master/RELAZIONE-Ierardi_Rizzi.pdf",

      description:'The aim of the project is to show the development and realization of a smart bench press that monitors the state, performance and health of the atlete during a session training with sensors. In particular, the SmartBench reads and elaborates the data that come from three different sensors: <ul> \
        <li class="mb-4">gym weights: monitor variation of weights.</li> \
        <li class="mb-4">  barbell: monitor repetition (barbell lifted up and down) and if the barbell is placed in the initial position.</li> \
        <li class="mb-4">  bracelet: monitor heartbeat and heart rate.</li> \
      </ul>'
    }, 
  ],

        
  recommendations: [
    {
      title: "Won 3rd place at the Google & SKY UK GenAI Hackathon (11 teams) for innovative AI solutions",
      date: "2024",
      company: "Google & SKY UK",
      location: "UK"
    },
    {
      title: "Won 3rd place at the Google & SKY UK GenAI Hackathon (11 teams) for innovative AI solutions",
      date: "2023",
      company: "Google & SKY UK",
      location: "UK"
    },
    {
      title: "PwC DesignWith Data VirtualWorkshop: DataMind group - 2° place",
      date: "2020",
      company: "PwC",
      location: "Milan"
    },
    {
      title: "DSU Lombardia - Scholarship",
      date: "2019",
      company: "University of Milan",
      location: ""
    },
    {
      title: "EDISU Piemonte - Scholarship",
      date: "2018",
      company: "University of Easter Piedmont",
      location: ""
    },
    {
      title:
      "Project cited by Società Italiana di Statistica (SIS)",
      date: "2019 - days: 30/03 and 31/03",
      company: "",
      location: "",
      description:'<a target="_blank" class="cta-btn text-color-main" href= "https://www.sis-statistica.it/ita/56/index.php?p=9989" > Reference </a>'
    }
  ]
};

export default info;
